import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		defaultMessage: 'Status page created! Set it up in a few simple steps.',
		description: 'Heading for the Statuspage edit spotlight',
		id: 'statuspage.edit-spotlight.heading',
	},
	body: {
		defaultMessage:
			'Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes.',
		description: 'Body text for the Statuspage edit spotlight',
		id: 'statuspage.edit-spotlight.body',
	},
	primaryAction: {
		defaultMessage: 'Done',
		description: 'Primary action button for the Statuspage edit spotlight',
		id: 'statuspage.edit-spotlight.action',
	},
});
